import { cloneDeep } from 'lodash'

import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, services } from '@/utils'

import button from '@/components/button'
import form from '@/components/services/documentTemplates/generate/form/invoice'

function renderForm(h) {
  return h(
    form,
    {
      class: 'pt-2 px-2',
      props: {
        value: this.proxy,
        OwnerId: this.OwnerId,
        ResellerId: this.ResellerId
      },
      on: {
        input: event => {
          this.proxy = event
        },
        validation: event => {
          this.formValidation = event
        }
      }
    }
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: 'fjcfe facfe grid-gap--8 pa-2',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.close()
            }
          }
        }
      ),
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.detach'),
            mode: buttonModes.flat,
            color: Colors.error
          },
          on: {
            click: () => {
              this.submit(false)
            }
          }
        }
      ),
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.save'),
            color: Colors.primary,
            disabled: !this.validation
          },
          on: {
            click: () => {
              // здесь нужен cloneDeep потому что в цикле есть форма
              // @/components/services/documentTemplates/generate/form/invoice
              // данные по ссылке снаружи могут превратиться там в undefined
              // так как у этой формы есть цикл beforeDestroy
              this.submit(cloneDeep(this.proxy))
            }
          }
        }
      )
    ]
  )
}
export default function(h) {
  let dialogMaxWidth
  if (this.viewport.breakpoint.mdUp) {
    dialogMaxWidth = 400
  }

  return h(
    components.dialog,
    {
      props: {
        title: this.getTranslate(`${services.invoices}.labels.create`),
        value: this.show,
        maxWidth: dialogMaxWidth
      }
    },
    [
      renderForm.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
